import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { AppErrorBoundary } from "./components/errors/AppErrorBoundary";
import { clearChunkReloadFlag } from "./utils/loadWithChunkRetry";
import { hydrateSessionFromOpener } from "./utils/openCertificationWindow";

hydrateSessionFromOpener();
clearChunkReloadFlag();

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Missing #root element — cannot mount iTEMA.");
}

createRoot(rootElement).render(
  <StrictMode>
    <AppErrorBoundary>
      <AuthProvider>
        <App />
      </AuthProvider>
    </AppErrorBoundary>
  </StrictMode>,
);
